import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
/** Services Import */
import Commons from "../../../Services/Common/Common";
import Dialog from "../../../Services/Common/Dialog";
import IndexedDb from "../../../Services/IndexedDb/IndexedDb";
/** Drawer Import */
import { DrawerActions } from "../../../Reducers/DrawerReducer";
/** Components Import */
import Snackbar from "../../../Components/Snackbar";
import Global from "../../../Services/Common/Global";
function Sidebar() {
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Dispatch 사용을 위한 저장
  const drawerStates = useSelector((state) => state.Drawer); // Drawer Redux 호출
  const [snackbars, setSnackbars] = React.useState({
    toggle: false,
    type: "",
    message: "",
  });
  const [lCatego, setLCatego] = useState([]);
  const [mCatego, setMCatego] = useState([]);
  const [lanList, setLanList] = useState([]);
  const [userId, setUserId] = React.useState("");
  React.useEffect(() => {
    Init();
  }, []);

  const Init = async () => {
    Dialog.ProgressBar(true);

    try {
      await IndexedDb.GetLoginInfo().then((result) => {
        setUserId(result.userId);
      });
      await IndexedDb.GetAllDb("MenuList").then((result) => {
        if (result.length > 0) {
          setLCatego(result.filter((f) => f.screenType === "L"));
          setMCatego(result.filter((f) => f.screenType === "M"));
        }
      });
      await IndexedDb.GetAllDb("LanguageList").then((result) => {
        if (result.length) {
          setLanList(result);
        }
      });
    } catch (e) {
      setSnackbars({
        toggle: true,
        type: "error",
        message: e.message,
      });
    } finally {
      Dialog.ProgressBar(false);
    }
  };

  const CloseMobileMenu = () => {
    let aside = document.querySelector(".aside");
    aside.style.display = "none";
    dispatch(DrawerActions.closeMobileMenuToggle());
  };

  const logout = async () => {
    CloseMobileMenu();
    Commons.Storages("set", "authorization", {
      authorization: false,
      authDate: Commons.DateFormating(new Date()),
    });
    navigate("/");
    try {
      await Commons.Axios(
        "post",
        Global.serverUrls.useUrl + Global.urls.logic.Common.LogOut,
        {
          userId: userId,
        }
      ).then((result) => {
        let data = result.data;
        IndexedDb.ClearDb("LoginInfo");
      });
    } catch (e) {}
    // navigate("/");
  };

  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  };

  // Menu 뿌리는 로직 함수
  const CreateMenus = () => {
    if (lCatego.length < 0) {
      return null;
    }
    if (lanList.length < 0) {
      return null;
    }

    const result = lCatego.map((item, index) => {
      const mCategoArr = mCatego.filter((f) => f.lcategoCd === item.lcategoCd);

      const LargeMenuClick = (_id, _index) => {
        let documentQuery = document.querySelector("#mCategoMenu" + _index);
        if (mCategoArr.length > 0) {
          if (drawerStates.mobileMenuToggle) {
            for (let i = 0; i < lCatego.length; i++) {
              if (i !== _index) {
                let temp = document.querySelector("#mCategoMenu" + i);
                temp.style.display = "none";
              }
            }
            if (documentQuery.style.display === "none") {
              documentQuery.style.display = "block";
            } else {
              documentQuery.style.display = "none";
            }
          } else {
            return null;
          }
        } else {
          navigate(_id);
          dispatch(
            DrawerActions.setAppBarLTitle(
              lanList.length > 0
                ? lanList.filter((f) => f.lanId === item.mcategoCd)[0].lanName
                : null
            )
          );
          dispatch(DrawerActions.closeMobileMenuToggle());
        }
      };
      let aTag = "";
      return (
        <li key={index}>
          <a onClick={() => LargeMenuClick(item.mcategoCd, index)}>
            <i className={"icon_menu0" + item.seq}></i>
            <span>
              {lanList.length > 0
                ? lanList.filter(
                    (f) => f.lanId === item.mcategoCd && f.lanType === "MENU"
                  )[0].lanName
                : null}
            </span>
          </a>
          {mCategoArr.length > 0 ? (
            <ul
              id={"mCategoMenu" + index}
              style={{ display: isMobile() ? "none" : "block" }}
            >
              {mCategoArr.map((item2, index2) => {
                // if (!isMobile() && item2.mobile === "Y") {
                // 	return;
                // }
                return (
                  <li
                    key={index2}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // navigate(item2.lcategoCd + "/" + item2.mcategoCd);
                      dispatch(
                        DrawerActions.setAppBarLTitle(
                          lanList.length > 0
                            ? lanList.filter(
                                (f) => f.lanId === item.mcategoCd
                              )[0].lanName
                            : null
                        )
                      );
                      dispatch(
                        DrawerActions.setAppBarMTitle(
                          lanList.length > 0
                            ? lanList.filter(
                                (f) => f.lanId === item2.mcategoCd
                              )[0].lanName
                            : null
                        )
                      );
                      if (isMobile()) {
                        CloseMobileMenu();
                      }
                    }}
                  >
                    <Link
                      to={"/" + item2.lcategoCd + "/" + item2.mcategoCd}
                      target={
                        item2.mcategoCd == "MM10060"
                          ? null
                          : "_blank" && item2.mcategoCd == "MM10070"
                          ? null
                          : "_blank" && item2.mcategoCd == "SM10060"
                          ? null
                          : "_blank" && item2.mcategoCd == "ST10040"
                          ? null
                          : "_blank"
                      }
                    >
                      {lanList.length > 0
                        ? lanList.filter((f) => f.lanId === item2.mcategoCd)[0]
                            .lanName
                        : null}
                    </Link>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </li>
      );
    });

    return result;
  };

  return (
    <>
      <aside id="aside" className="aside">
        {drawerStates.mobileMenuToggle && (
          <button
            type="button"
            id="btnClose"
            aria-label="메뉴 닫기"
            onClick={() => {
              let aside = document.querySelector(".aside");
              aside.style.display = "none";
              dispatch(DrawerActions.closeMobileMenuToggle());
            }}
          />
        )}
        <ul className="side_nav">
          {CreateMenus()}
          <li>
            <a onClick={logout}>
              <i className={"icon_menu99"}></i>
              <span>로그아웃</span>
            </a>
          </li>
        </ul>
      </aside>
      {snackbars.toggle && (
        <Snackbar snackbars={snackbars} setSnackbars={setSnackbars} />
      )}
    </>
  );
}

export default Sidebar;
